// extracted by mini-css-extract-plugin
module.exports = {"watermark":"waterMark_watermark__SokWL","label":"waterMark_label__oNwlJ"};